<button class="button" type="submit" [disabled]="disabled">
    <div class="button-label">
        <div class="button-label-title" id="label">
            {{ title | translate }}
        </div>
    </div>
</button>
